export default __webpack_public_path__ + "dgh_sm@2x.e256adef.png";